import { Component, Inject, OnInit } from '@angular/core'
import { environment } from '../environments/environment'
import { NGXLogger, NgxLoggerLevel } from 'ngx-logger'
import { TranslateService } from '@ngx-translate/core'
import { DOCUMENT } from '@angular/common'
import { Title } from '@angular/platform-browser'

@Component({
  selector: 'cover-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private readonly logger: NGXLogger,
    private readonly translate: TranslateService,
    private readonly title: Title,
    @Inject(DOCUMENT) private document: Document,
  ) {
    if (environment.production) this.logger.updateConfig({ level: NgxLoggerLevel.INFO })
    translate.setDefaultLang('de')
    translate.use('de')
  }

  ngOnInit(): void {
    this.setCustomerStyleSheet()
    this.setTitleAndFavicon()
  }

  private setCustomerStyleSheet(): void {
    const head = this.document.getElementsByTagName('head')[0]

    const style = this.document.createElement('link')
    style.id = 'client-style'
    style.rel = 'stylesheet'
    style.href = environment.customerStyleSheet

    head.appendChild(style)
  }

  private setTitleAndFavicon(): void {
    if (environment.title) {
      this.title.setTitle(environment.title)
    }

    if (environment.favicon) {
      const favicon = this.document.querySelector('link[rel="icon"]') as HTMLLinkElement
      favicon.href = environment.favicon
    }
  }
}
